import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPipe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPipe"><Path d="M3 20.5H21" stroke="currentColor"/><Path d="M18.25 10.75V20.25" stroke="currentColor"/><Path d="M5.75 20.25V10.75" stroke="currentColor"/><Path d="M3.5 3.5H20.5V10.5H3.5V3.5Z" stroke="currentColor"/><Path d="M7.75 3.75V10.25" stroke="currentColor"/><Path d="M9.75 10.75V20.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconPipe;
